import { FormElementField, useFormField } from 'components/FormElements';
import { CONTACT_FIELDS } from 'components/FormElements/constants';
import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

export const BillingContactInput = ({
  contactDetails = {},
  errors = {},
  fieldName,
  setContactDetails,
  setErrors,
  ...inputProps
}) => {
  const { setBillingErrorMessage } = useSelectPlanCheckoutContext();

  const { [fieldName]: errorMessage } = errors;
  const { [fieldName]: fieldValue } = contactDetails;

  const setFieldValue = (value) => {
    setBillingErrorMessage && setBillingErrorMessage('');
    setContactDetails &&
      setContactDetails({ ...contactDetails, [fieldName]: value });
  };

  const { handleOnBlur, handleOnChange } = useFormField({
    errors,
    fieldName,
    setErrors,
    setFieldValue,
    trackingEventName: 'billingContactInfo',
    trackingEventType: 'selectPlanCheckout',
  });

  const fieldProps = {
    error: errorMessage,
    id: `billing-contact-${fieldName}-input`,
    onBlur: handleOnBlur,
    onChange: handleOnChange,
    ...inputProps,
    ...CONTACT_FIELDS[fieldName],
  };

  return <FormElementField value={fieldValue} {...fieldProps} />;
};
